import useFetch from "use-http"
import { getAbsoluteServerUrl } from "../config/config"
import { Source } from "../config/indicators-model";

export type MapMetric = {
    id: number,
    name: string,
    unit: string,
    periodicity?: string,
    sources?: Source[],
    description?: string,
    range?: number[]
}

export function useGetMapMetrics() {
    return useFetch<MapMetric[]>(getAbsoluteServerUrl('/map/metrics'), { responseType: 'json' }, [])
}
